/* NC Teppich nach Maß – Konfigurator (UI, Plan-Ansicht, 3D, Warenkorb)
 * Abhängig von: nc-tnm-price.js (window.NcTnmPrice)
 * 3D: three.js wird erst geladen, wenn der Konfigurator sichtbar ist.
 */
(function () {
  'use strict';

  var THREE_URL = window.NC_TNM_THREE_URL || 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js';
  var MV_URL = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.3.1/dist/model-viewer.min.js';
  var QR_URL = 'https://cdn.jsdelivr.net/npm/qrcode-generator@2.0.4/dist/qrcode.js';
  var TILE_M = 0.9;    // das Fotomotiv wird auf ca. 90 × 90 cm Fell abgebildet (Langhaar)
  var TILE_BY_TYPE = { langhaar: 0.9, kurzhaar: 0.4, tibet: 0.55 };
  var PERIOD_M = 2.0;  // die erzeugte Felloberfläche wiederholt sich erst nach 2 × 2 m
  var SURF_PX = 2048;
  var PILE_M = { kurzhaar: 0.025, langhaar: 0.06, tibet: 0.09 };
  /* Echtes Fell in 3D: mehrere dünne Schichten ("Shells") über dem Grundkörper.
     layers = Anzahl Schichten, base = Anteil Unterwolle, lean = Neigung der Haarspitzen (m),
     strand = Haarbreite (px auf 512 = 0,5 m), clump = Lockengröße (px), curl = Korkenzieher-Anteil */
  var FUR = {
    langhaar: { layers: 22, base: 0.34, lean: 0.016, strand: 4, clump: 26, curl: 0, sway: 0.004 },
    kurzhaar: { layers: 14, base: 0.46, lean: 0.004, strand: 2, clump: 10, curl: 0.35, sway: 0.0012 },
    tibet:    { layers: 24, base: 0.28, lean: 0.007, strand: 4, clump: 16, curl: 1, sway: 0.003 }
  };
  var _strandCache = {};
  function strandCanvas(type) {
    if (_strandCache[type]) return _strandCache[type];
    var f = FUR[type] || FUR.langhaar, S = 512, rnd = mulberry(type.length * 97 + 13);
    var G = Math.round(S / f.clump), grid = [];
    for (var i = 0; i < G * G; i++) grid.push(rnd());
    var clumpAt = function (x, y) { // weiches, kachelbares Rauschen
      var gx = x / S * G, gy = y / S * G, x0 = Math.floor(gx), y0 = Math.floor(gy), fx = gx - x0, fy = gy - y0;
      var q = function (a, b) { return grid[((b % G + G) % G) * G + ((a % G + G) % G)]; };
      fx = fx * fx * (3 - 2 * fx); fy = fy * fy * (3 - 2 * fy);
      return (q(x0, y0) * (1 - fx) + q(x0 + 1, y0) * fx) * (1 - fy) + (q(x0, y0 + 1) * (1 - fx) + q(x0 + 1, y0 + 1) * fx) * fy;
    };
    var c = document.createElement('canvas'); c.width = c.height = S;
    var ctx = c.getContext('2d'), img = ctx.createImageData(S, S), d = img.data, st = f.strand, cells = S / st;
    var cellH = new Float32Array(cells * cells);
    for (var cy = 0; cy < cells; cy++) for (var cx = 0; cx < cells; cx++) {
      var cl = clumpAt(cx * st + st / 2, cy * st + st / 2);
      var hgt = 0.25 + 0.75 * (0.5 * rnd() + 0.5 * cl);
      if (cl < 0.22) hgt *= cl / 0.22;                        // Scheitel zwischen den Locken
      if (f.curl) hgt *= 1 - f.curl * 0.35 * (0.5 + 0.5 * Math.sin((cx + cy * 0.6) * 1.9 + cl * 9));
      cellH[cy * cells + cx] = Math.max(0, Math.min(1, hgt));
    }
    for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) {
      var cx2 = Math.floor(x / st), cy2 = Math.floor(y / st), v = cellH[cy2 * cells + cx2];
      var lx = (x % st) / st - 0.5, ly = (y % st) / st - 0.5;          // runder Haarquerschnitt
      if (st > 2 && lx * lx + ly * ly > 0.22) v *= 0.35;
      var k = (y * S + x) * 4, b = Math.round(v * 255);
      d[k] = d[k + 1] = d[k + 2] = b; d[k + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    return (_strandCache[type] = c);
  }

  /* ---------------- Hilfsfunktionen ---------------- */
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function money(cents, cfg) {
    try {
      return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cfg.currency; }
  }
  function num(n, dec, locale) {
    return new Intl.NumberFormat(locale, { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(n);
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) n--; }
    return d;
  }
  function fmtDate(d, locale) {
    return d.toLocaleDateString(locale, { day: 'numeric', month: 'long' });
  }

  /* Kachel nahtlos machen: um eine halbe Kachel versetzte Kopie unterlegen und das Original
     zur Mitte hin einblenden – erst horizontal, dann vertikal. So entstehen keine sichtbaren Kanten. */
  function mkCanvas(n) { var c = document.createElement('canvas'); c.width = c.height = n; return c; }
  function seamless(src) {
    var n = src.width;
    function pass(img, horiz) {
      var o = mkCanvas(n), g = o.getContext('2d'), h = n / 2;
      if (horiz) { g.drawImage(img, h, 0, h, n, 0, 0, h, n); g.drawImage(img, 0, 0, h, n, h, 0, h, n); }
      else { g.drawImage(img, 0, h, n, h, 0, 0, n, h); g.drawImage(img, 0, 0, n, h, 0, h, n, h); }
      var a = mkCanvas(n), ag = a.getContext('2d');
      ag.drawImage(img, 0, 0);
      ag.globalCompositeOperation = 'destination-in';
      var gr = horiz ? ag.createLinearGradient(0, 0, n, 0) : ag.createLinearGradient(0, 0, 0, n);
      gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(0.32, 'rgba(0,0,0,1)');
      gr.addColorStop(0.68, 'rgba(0,0,0,1)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      ag.fillStyle = gr; ag.fillRect(0, 0, n, n);
      g.drawImage(a, 0, 0);
      return o;
    }
    return pass(pass(src, true), false);
  }

  /* Großflächige Helligkeitsunterschiede im Foto ausgleichen, damit keine Muster entstehen */
  function flatten(c) {
    var n = c.width;
    try {
      var sm = mkCanvas(12), sg = sm.getContext('2d');
      sg.imageSmoothingQuality = 'high'; sg.drawImage(c, 0, 0, 12, 12);
      var bl = mkCanvas(n), bg = bl.getContext('2d');
      bg.imageSmoothingQuality = 'high'; bg.drawImage(sm, 0, 0, n, n);
      var sd = sg.getImageData(0, 0, 12, 12).data, m = [0, 0, 0];
      for (var i = 0; i < sd.length; i += 4) { m[0] += sd[i]; m[1] += sd[i + 1]; m[2] += sd[i + 2]; }
      m = m.map(function (v) { return v / 144; });
      var g = c.getContext('2d'), id = g.getImageData(0, 0, n, n), d = id.data, b = bg.getImageData(0, 0, n, n).data;
      for (var j = 0; j < d.length; j += 4) {
        for (var k = 0; k < 3; k++) { var f = m[k] / Math.max(8, b[j + k]); var v = d[j + k] * (1 + (f - 1) * 0.75); d[j + k] = v > 255 ? 255 : v; }
      }
      g.putImageData(id, 0, 0);
    } catch (e) { /* ohne CORS: unverändert */ }
    return c;
  }

  /* Eine durchgehende Felloberfläche erzeugen: Fellstücke zufällig platziert und leicht gedreht
     (wie zusammengenähte Felle), dazu weiche Tonflecken. Randlos wiederholbar, Periode PERIOD_M. */
  function furSurface(src, seed, tileM) {
    var TILE_M = tileM || TILE_BY_TYPE.langhaar;
    var N = SURF_PX, rnd = mulberry(seed || 7), o = mkCanvas(N), g = o.getContext('2d');
    var patchPx = Math.round(0.6 * TILE_M / PERIOD_M * N);
    var base = seamless(src), sc = (TILE_M / PERIOD_M * N) / src.width;
    g.save(); g.scale(sc, sc); g.fillStyle = g.createPattern(base, 'repeat'); g.fillRect(0, 0, N / sc, N / sc); g.restore();
    var p = mkCanvas(patchPx), pg = p.getContext('2d'), r = patchPx / 2, count = 120;
    function wrap(x, y, R, fn) {
      for (var dx = -1; dx <= 1; dx++) for (var dy = -1; dy <= 1; dy++) {
        var cx = x + dx * N, cy = y + dy * N;
        if (cx < -R || cx > N + R || cy < -R || cy > N + R) continue;
        fn(cx, cy);
      }
    }
    for (var i = 0; i < count; i++) {
      pg.globalCompositeOperation = 'source-over'; pg.clearRect(0, 0, patchPx, patchPx);
      var ss = src.width * 0.6, ox = rnd() * (src.width - ss), oy = rnd() * (src.width - ss);
      pg.drawImage(src, ox, oy, ss, ss, 0, 0, patchPx, patchPx);
      pg.globalCompositeOperation = 'destination-in';
      var gr = pg.createRadialGradient(r, r, r * 0.35, r, r, r);
      gr.addColorStop(0, 'rgba(0,0,0,1)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      pg.fillStyle = gr; pg.fillRect(0, 0, patchPx, patchPx);
      var x = rnd() * N, y = rnd() * N, a = (rnd() - 0.5) * 1.2;
      wrap(x, y, patchPx, function (cx, cy) { g.save(); g.translate(cx, cy); g.rotate(a); g.drawImage(p, -r, -r); g.restore(); });
    }
    for (var k = 0; k < 10; k++) {
      var bx = rnd() * N, by = rnd() * N, R = N * (0.18 + rnd() * 0.16), dark = rnd() < 0.5;
      wrap(bx, by, R, function (cx, cy) {
        var col = dark ? '0,0,0' : '255,255,255', rg = g.createRadialGradient(cx, cy, 0, cx, cy, R);
        rg.addColorStop(0, 'rgba(' + col + ',' + (dark ? 0.055 : 0.045) + ')'); rg.addColorStop(1, 'rgba(' + col + ',0)');
        g.fillStyle = rg; g.fillRect(cx - R, cy - R, 2 * R, 2 * R);
      });
    }
    return o;
  }

  /* Ausschnitt aus der Bildmitte eines Fell-Packshots als nahtlose Textur */
  var cropCache = {};
  /* src = { url, s: Anteil der kurzen Bildseite, x/y: Mittelpunkt 0..1 } */
  function loadCrop(src) {
    if (typeof src === 'string') src = { url: src, s: 0.42, x: 0.5, y: 0.5 };
    var key = src.url + '|' + src.s + '|' + src.x + '|' + src.y + '|' + (src.m || '');
    if (cropCache[key]) return cropCache[key];
    var url = src.url;
    cropCache[key] = new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var s = Math.min(img.naturalWidth, img.naturalHeight) * (src.s || 0.42);
        var sx = img.naturalWidth * (src.x == null ? 0.5 : src.x) - s / 2, sy = img.naturalHeight * (src.y == null ? 0.5 : src.y) - s / 2;
        sx = Math.max(0, Math.min(img.naturalWidth - s, sx)); sy = Math.max(0, Math.min(img.naturalHeight - s, sy));
        var raw = mkCanvas(1024);
        raw.getContext('2d').drawImage(img, sx, sy, s, s, 0, 0, 1024, 1024);
        var c = furSurface(flatten(raw), 7, src.m);
        var ctx = c.getContext('2d');
        var avg = [0, 0, 0];
        try {
          var px = ctx.getImageData(512, 512, 1024, 1024).data, n = 0;
          for (var i = 0; i < px.length; i += 64) { avg[0] += px[i]; avg[1] += px[i + 1]; avg[2] += px[i + 2]; n++; }
          avg = avg.map(function (v) { return Math.round(v / n); });
        } catch (e) { avg = [200, 190, 175]; }
        var dataUrl;
        try { var small = mkCanvas(1024); small.getContext('2d').drawImage(c, 0, 0, 1024, 1024); dataUrl = small.toDataURL('image/jpeg', 0.85); } catch (e) { dataUrl = url; }
        resolve({ canvas: c, dataUrl: dataUrl, avg: avg });
      };
      img.onerror = reject;
      img.src = url;
    });
    return cropCache[key];
  }

  function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function sameColor(a, b) { a = norm(a); b = norm(b); return a === b || a.indexOf(b + ' ') === 0 || b.indexOf(a + ' ') === 0; }

  /* Standardgröße aus Optionswert/Titel lesen: "120x180 cm" -> rect, "D180 cm" -> round */
  function parseSize(str) {
    var m = /D\s*(\d{2,4})/i.exec(str);
    if (m) return { shape: 'round', w: +m[1], l: +m[1], d: +m[1], key: 'r' + m[1] };
    m = /(\d{2,4})\s*[x×]\s*(\d{2,4})/i.exec(str);
    if (m) return { shape: 'rect', w: +m[1], l: +m[2], d: 0, key: m[1] + 'x' + m[2] };
    return null;
  }

  /* ---------------- Konfigurator ---------------- */
  function Configurator(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-tnm-config]').textContent);
    this.state = {
      type: this.cfg.types[0].key,
      shape: 'rect',
      w: this.cfg.defaults.w, l: this.cfg.defaults.l, d: this.cfg.defaults.d,
      variantId: null,
      room: 'sofa',
      view: '3d'
    };
    this.engaged = false; // Kaufleiste erst zeigen, wenn der Kunde ein Maß wählt
    this.prepareStd();
    this.readUrl();
    this.bind();
    this.renderTypes();
    this.renderColors();
    this.renderPresets();
    this.syncInputs();
    this.update();
    this.initStage();
  }

  Configurator.prototype.prepareStd = function () {
    this.cfg.types.forEach(function (t) {
      var sizes = {};
      (t.std || []).forEach(function (e) {
        var sz = parseSize(e.s);
        if (!sz) return;
        e.size = sz;
        if (!sizes[sz.key]) sizes[sz.key] = { size: sz, price: e.p, entries: [] };
        sizes[sz.key].entries.push(e);
        sizes[sz.key].price = Math.min(sizes[sz.key].price, e.p);
      });
      t.stdSizes = Object.keys(sizes).map(function (k) { return sizes[k]; }).sort(function (a, b) {
        if (a.size.shape !== b.size.shape) return a.size.shape === 'rect' ? -1 : 1;
        return a.size.w * a.size.l - b.size.w * b.size.l;
      });
    });
  };

  /* Passt die aktuelle Auswahl exakt zu einer Standardgröße in dieser Farbe? */
  Configurator.prototype.stdMatch = function () {
    var s = this.state, t = this.type(), v = this.variant();
    var hit = null, sizeOnly = null;
    (t.stdSizes || []).forEach(function (g) {
      var z = g.size, ok;
      if (s.shape !== z.shape) return;
      ok = z.shape === 'round' ? s.d === z.d : ((s.w === z.w && s.l === z.l) || (s.w === z.l && s.l === z.w));
      if (!ok) return;
      sizeOnly = g;
      g.entries.forEach(function (e) { if (!hit && e.a && sameColor(e.c, v.name)) hit = e; });
    });
    return { entry: hit, size: sizeOnly };
  };

  /* Beste Bildquelle für die Fellstruktur einer Farbe */
  Configurator.prototype.texSource = function (v, t) {
    t = t || this.type();
    var m = TILE_BY_TYPE[t.key] || TILE_M;
    if (v.tex) return { url: v.tex, s: 0.9, x: 0.5, y: 0.5, kind: 'tex', m: m };
    var std = (t.std || []).filter(function (e) { return e.img && sameColor(e.c, v.name) && e.size && e.size.shape === 'rect'; })[0]
      || (t.std || []).filter(function (e) { return e.img && sameColor(e.c, v.name); })[0];
    if (std) return { url: std.img, s: std.size && std.size.shape === 'round' ? 0.34 : 0.42, x: 0.5, y: 0.5, kind: 'rug', m: m };
    return { url: v.image, s: 0.17, x: 0.5, y: 0.42, kind: 'chair', m: m };
  };

  /* Farben (Varianten), die es in dieser Standardgröße gibt */
  Configurator.prototype.stdColorsFor = function (g) {
    var t = this.type();
    if (!g) return [];
    return t.variants.filter(function (v) { return g.entries.some(function (e) { return e.a && sameColor(e.c, v.name); }); });
  };

  Configurator.prototype.type = function () {
    var k = this.state.type;
    return this.cfg.types.filter(function (t) { return t.key === k; })[0];
  };
  Configurator.prototype.variant = function () {
    var t = this.type(), id = this.state.variantId;
    return t.variants.filter(function (v) { return v.id === id; })[0] || t.variants[0];
  };

  Configurator.prototype.readUrl = function () { this.applyParams(new URLSearchParams(window.location.search)); };

  /* Von außen aufrufbar (Inspiration, Felltyp-Karten): Parameter übernehmen und neu zeichnen */
  Configurator.prototype.apply = function (params) {
    var before = this.state.type;
    this.applyParams(params);
    if (this.state.type !== before && !params.get('farbe')) this.state.variantId = null;
    this.renderTypes(); this.renderColors(); this.renderPresets(); this.syncInputs(); this.update();
    if (this._stkRefresh) this._stkRefresh();
  };

  Configurator.prototype.engage = function () {
    if (this.engaged) return;
    this.engaged = true;
    if (this._stkRefresh) this._stkRefresh();
  };

  Configurator.prototype.applyParams = function (p) {
    var s = this.state, cfg = this.cfg;
    if (['b', 'l', 'd'].some(function (k) { return p.get(k); })) this.engaged = true;
    if (p.get('typ') && cfg.types.some(function (t) { return t.key === p.get('typ'); })) s.type = p.get('typ');
    if (p.get('form') === 'rund' || p.get('form') === 'rect' || p.get('form') === 'eckig') s.shape = p.get('form') === 'rund' ? 'round' : 'rect';
    ['b', 'l', 'd'].forEach(function (k) {
      var v = parseInt(p.get(k), 10);
      if (!isNaN(v) && NcTnmPrice.validate(v, cfg.minCm, cfg.maxCm) === null) s[k === 'b' ? 'w' : k] = v;
    });
    if (p.get('farbe')) {
      var t = this.type(), name = p.get('farbe').toLowerCase();
      var match = t.variants.filter(function (v) { return v.name.toLowerCase() === name; })[0];
      if (match) s.variantId = match.id;
    }
  };

  Configurator.prototype.shareUrl = function () {
    var s = this.state, u = new URL(window.location.href);
    ['typ', 'form', 'b', 'l', 'd', 'farbe', 'preview_theme_id'].forEach(function (k) { if (k !== 'preview_theme_id') u.searchParams.delete(k); });
    u.searchParams.set('typ', s.type);
    u.searchParams.set('form', s.shape === 'round' ? 'rund' : 'eckig');
    if (s.shape === 'round') u.searchParams.set('d', s.d); else { u.searchParams.set('b', s.w); u.searchParams.set('l', s.l); }
    u.searchParams.set('farbe', this.variant().name);
    u.hash = 'teppich-konfigurator';
    return u.toString();
  };

  Configurator.prototype.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tnm-type]');
      if (t) { self.state.type = t.getAttribute('data-tnm-type'); self.state.variantId = null; self.renderTypes(); self.renderColors(); self.renderPresets(); self.update(); return; }
      var sh = e.target.closest('[data-tnm-shape]');
      if (sh) { self.state.shape = sh.getAttribute('data-tnm-shape'); self.engage(); self.update(); return; }
      var c = e.target.closest('[data-tnm-color]');
      if (c) { self.state.variantId = parseInt(c.getAttribute('data-tnm-color'), 10); self.renderColors(); self.renderPresets(); self.update(); return; }
      var st = e.target.closest('[data-tnm-step]');
      if (st) {
        var key = st.getAttribute('data-tnm-step'), dir = parseInt(st.getAttribute('data-dir'), 10);
        var cur = parseInt(self.state[key], 10) || self.cfg.minCm;
        self.state[key] = Math.min(self.cfg.maxCm, Math.max(self.cfg.minCm, cur + dir));
        self.engage();
        self.syncInputs(); self.update(); return;
      }
      var room = e.target.closest('[data-tnm-room]');
      if (room) { self.state.room = room.getAttribute('data-tnm-room'); self.update(); return; }
      var view = e.target.closest('[data-tnm-view]');
      if (view) { self.setView(view.getAttribute('data-tnm-view')); return; }
      if (e.target.closest('[data-tnm-share]')) { self.share(e.target.closest('[data-tnm-share]')); return; }
      if (e.target.closest('[data-tnm-add]')) { self.addToCart(); return; }
      if (e.target.closest('[data-tnm-ar]')) { self.onAR(); return; }
      if (e.target.closest('[data-tnm-arqr-close]')) { $(root, '[data-tnm-arqr]').hidden = true; return; }
      if (e.target.closest('[data-tnm-scroll-summary]')) { $(root, '.tnm-summary').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (e.target.closest('[data-tnm-topview]')) { if (self.three) self.three.topView(); return; }
    });

    $$(root, '[data-tnm-input]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var key = inp.getAttribute('data-tnm-input');
        self.state[key] = inp.value === '' ? '' : Number(inp.value);
        self.engage();
        $$(root, '[data-tnm-input="' + key + '"]').forEach(function (o) { if (o !== inp) o.value = inp.value; });
        self.update();
      });
      inp.addEventListener('blur', function () {
        var key = inp.getAttribute('data-tnm-input');
        var v = Number(self.state[key]);
        if (isFinite(v) && self.state[key] !== '') {
          v = Math.round(v);
          self.state[key] = Math.min(self.cfg.maxCm, Math.max(self.cfg.minCm, v));
          self.syncInputs(); self.update();
        }
      });
    });

    var confirm = $(root, '[data-tnm-confirm]');
    if (confirm) confirm.addEventListener('change', function () { self.update(); });

    // Kaufleiste: sichtbar, sobald der Konfigurator erreicht bzw. passiert ist – außer die Zusammenfassung ist zu sehen
    var bar = $(root, '[data-tnm-stickybar]'), summary = $(root, '.tnm-summary');
    if (bar && summary && 'IntersectionObserver' in window) {
      var inView = { summary: false }, reached = false;
      var refresh = function () {
        var r = root.getBoundingClientRect();
        reached = r.top < window.innerHeight * 0.35;
        var on = self.engaged && reached && !inView.summary;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.inert = !on;
      };
      self._stkRefresh = refresh;
      new IntersectionObserver(function (en) { inView.summary = en[0].isIntersecting; refresh(); }, { threshold: 0.15 }).observe(summary);
      window.addEventListener('scroll', function () { if (!self._stkRaf) self._stkRaf = requestAnimationFrame(function () { self._stkRaf = null; refresh(); }); }, { passive: true });
      bar.addEventListener('click', function (e) {
        var top = e.target.closest('[data-tnm-scroll-top]');
        if (top) { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      refresh();
    }
    this.initAR();
  };

  Configurator.prototype.syncInputs = function () {
    var s = this.state;
    $$(this.root, '[data-tnm-input]').forEach(function (inp) {
      var k = inp.getAttribute('data-tnm-input');
      if (String(inp.value) !== String(s[k])) inp.value = s[k];
    });
  };

  Configurator.prototype.renderTypes = function () {
    var k = this.state.type;
    $$(this.root, '[data-tnm-type]').forEach(function (b) {
      var on = b.getAttribute('data-tnm-type') === k;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
  };

  Configurator.prototype.renderColors = function () {
    var t = this.type(), wrap = $(this.root, '[data-tnm-colors]'), self = this;
    if (!this.state.variantId || !t.variants.some(function (v) { return v.id === self.state.variantId; })) {
      var def = t.variants.filter(function (v) { return (t.std || []).some(function (e) { return e.a && sameColor(e.c, v.name); }); })[0];
      this.state.variantId = (def || t.variants[0]).id;
    }
    wrap.innerHTML = t.variants.map(function (v) {
      var on = v.id === self.state.variantId;
      var src = self.texSource(v, t);
      var bgUrl = src.kind === 'chair' ? v.thumb : src.url.replace(/width=\d+/, 'width=400');
      var size = (100 / src.s).toFixed(0) + '%';
      var px = src.s >= 1 ? 50 : ((src.x - src.s / 2) / (1 - src.s) * 100).toFixed(1);
      var py = src.s >= 1 ? 50 : ((src.y - src.s / 2) / (1 - src.s) * 100).toFixed(1);
      return '<button type="button" class="tnm-swatch' + (on ? ' is-active' : '') + '" data-tnm-color="' + v.id + '" aria-pressed="' + on + '" title="' + v.name + '">' +
        '<span class="tnm-swatch__img" style="background-image:url(' + bgUrl + ');background-size:' + size + ';background-position:' + px + '% ' + py + '%"></span>' +
        '<span class="tnm-swatch__name">' + v.name + '</span></button>';
    }).join('');
    $(this.root, '[data-tnm-color-count]').textContent = t.variants.length;
  };

  /* Link zur passenden Variante des Standardteppichs: gleiche Farbe, sonst erste lieferbare */
  Configurator.prototype.stdUrl = function (g) {
    var v = this.variant();
    var e = g.entries.filter(function (x) { return x.a && sameColor(x.c, v.name); })[0]
      || g.entries.filter(function (x) { return x.a; })[0] || g.entries[0];
    return e && e.u ? e.u : '#';
  };

  Configurator.prototype.renderPresets = function () {
    var t = this.type(), c = this.cfg, self = this, wrap = $(this.root, '[data-tnm-presets]');
    if (!wrap) return;
    var list = $(wrap, '[data-tnm-preset-list]'), none = $(wrap, '[data-tnm-preset-none]');
    var sizes = t.stdSizes || [];
    list.innerHTML = sizes.map(function (g) {
      var z = g.size, label = z.shape === 'round' ? 'Ø ' + z.d + ' cm' : z.w + ' × ' + z.l + ' cm';
      return '<a class="tnm-std" href="' + self.stdUrl(g) + '">' +
        '<span class="tnm-std__size">' + label + '</span><span class="tnm-std__cta">' + (c.strings.stdCta || 'Se mattan →') + '</span></a>';
    }).join('');
    list.hidden = !sizes.length;
    $$(wrap, '.tnm-presets__label').forEach(function (el) { el.hidden = !sizes.length; });
    $$(wrap, '.tnm-presets__text').forEach(function (el) { el.hidden = !sizes.length; });
    if (none) none.hidden = !!sizes.length;
  };

  Configurator.prototype.errors = function () {
    var s = this.state, c = this.cfg, errs = {};
    var keys = s.shape === 'round' ? ['d'] : ['w', 'l'];
    keys.forEach(function (k) { var e = NcTnmPrice.validate(s[k], c.minCm, c.maxCm); if (e) errs[k] = e; });
    return errs;
  };

  Configurator.prototype.update = function () {
    var s = this.state, c = this.cfg, root = this.root, t = this.type(), v = this.variant();
    root.setAttribute('data-shape', s.shape);
    $$(root, '[data-tnm-shape]').forEach(function (b) {
      var on = b.getAttribute('data-tnm-shape') === s.shape; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
    $$(root, '[data-tnm-room]').forEach(function (b) {
      var on = b.getAttribute('data-tnm-room') === s.room; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });

    var errs = this.errors(), msgs = c.strings.errors;
    $$(root, '[data-tnm-error]').forEach(function (el) {
      var k = el.getAttribute('data-tnm-error');
      el.textContent = errs[k] ? msgs[errs[k]] : '';
      var field = el.closest('.tnm-dim'); if (field) field.classList.toggle('has-error', !!errs[k]);
    });
    var valid = Object.keys(errs).length === 0;

    // Texte
    $(root, '[data-tnm-color-name]').textContent = v.name;
    $$(root, '[data-tnm-out="type"]').forEach(function (el) { el.textContent = t.label; });
    $$(root, '[data-tnm-out="color"]').forEach(function (el) { el.textContent = v.name; });
    var sw = $(root, '[data-tnm-sticky-swatch]');
    if (sw) { var ts = this.texSource(v) || {}; if (ts.url) sw.style.backgroundImage = 'url("' + ts.url + '")'; sw.classList.toggle('is-round', s.shape === 'round'); }
    var dimTxt = s.shape === 'round' ? 'Ø ' + s.d + ' cm' : s.w + ' × ' + s.l + ' cm';
    $$(root, '[data-tnm-out="dims"]').forEach(function (el) { el.textContent = valid ? dimTxt : '–'; });
    $$(root, '[data-tnm-out="shape"]').forEach(function (el) { el.textContent = s.shape === 'round' ? c.strings.round : c.strings.rect; });

    var addBtns = $$(root, '[data-tnm-add]');
    var confirm = $(root, '[data-tnm-confirm]');
    // Maßanfertigung wird immer mit m²-Preis berechnet; entspricht das Maß einer Standardgröße, verlinken wir den Standardteppich
    var std = valid ? this.stdMatch() : { entry: null, size: null };
    var stdHint = $(root, '[data-tnm-std-hint]');
    if (stdHint) {
      stdHint.hidden = !std.size;
      if (std.size) {
        stdHint.innerHTML = '';
        stdHint.appendChild(document.createTextNode((c.strings.stdSame || '{mass} finns även som färdig standardmatta.').replace('{mass}', dimTxt) + ' '));
        var a = document.createElement('a'); a.href = this.stdUrl(std.size); a.textContent = c.strings.stdSameCta || 'Till standardmattan →';
        stdHint.appendChild(a);
      }
    }
    if (valid) {
      var r = NcTnmPrice.calc({
        mode: c.mode, shape: s.shape, w: s.w, l: s.l, d: s.d,
        unitPriceCents: v.price, pricePerSqmCents: c.pricePerSqmCents
      });
      this.result = r;
      var perSqm = c.mode === 'function' ? c.pricePerSqmCents : v.price * 100;
      // Gesamtpreis erst nach Maßeingabe; vorher nur der m²-Preis
      var eng = this.engaged;
      $$(root, '[data-tnm-out="price"]').forEach(function (el) { el.textContent = eng ? money(r.totalCents, c) : money(perSqm, c) + ' / m²'; });
      $$(root, '[data-tnm-out="persqm"]').forEach(function (el) { if (el.parentNode) el.parentNode.style.display = eng ? '' : 'none'; });
      $$(root, '.tnm-cta[data-tnm-add] > span').forEach(function (el) {
        if (!el._tnmLabel) el._tnmLabel = el.textContent;
        el.textContent = eng ? el._tnmLabel : (c.strings.calcPrice || 'Beräkna ditt pris');
      });
      $$(root, '[data-tnm-out="area"]').forEach(function (el) { el.textContent = num(r.m2, 2, c.locale) + ' m²'; });
      $$(root, '[data-tnm-out="persqm"]').forEach(function (el) { el.textContent = money(perSqm, c); });
      $$(root, '[data-tnm-out="kind"]').forEach(function (el) { el.textContent = c.strings.kindCustom; });
      $$(root, '[data-tnm-out="pricelabel"]').forEach(function (el) { el.textContent = eng ? c.strings.labelCustom : (c.strings.labelSqm || 'Pris per m²'); });
      var note = $(root, '[data-tnm-out="roundnote"]');
      if (note) note.hidden = s.shape !== 'round';
    } else {
      this.result = null;
      $$(root, '[data-tnm-out="price"],[data-tnm-out="area"]').forEach(function (el) { el.textContent = '–'; });
    }
    var needConfirm = confirm && !confirm.checked;
    addBtns.forEach(function (b) { b.disabled = !valid || needConfirm; });
    var hint = $(root, '[data-tnm-confirm-hint]');
    if (hint) hint.hidden = !(valid && needConfirm);

    // Lieferfenster (Fertigung + Versand, in Werktagen)
    var now = new Date();
    var fast = false;
    var from = addBusinessDays(now, fast ? c.leadDays.stockMin : c.leadDays.min), to = addBusinessDays(now, fast ? c.leadDays.stockMax : c.leadDays.max);
    $$(root, '[data-tnm-out="deliverynote"]').forEach(function (el) { el.textContent = fast ? c.strings.deliveryStock : c.strings.deliveryMade; });
    $$(root, '[data-tnm-out="delivery"]').forEach(function (el) {
      el.textContent = fmtDate(from, c.locale) + ' – ' + fmtDate(to, c.locale);
    });

    this.drawPlan(valid);
    if (this.three) this.three.update(this.sceneState(valid));
  };

  Configurator.prototype.sceneState = function (valid) {
    var s = this.state;
    return {
      valid: valid,
      shape: s.shape,
      w: (s.shape === 'round' ? s.d : s.w) / 100,
      l: (s.shape === 'round' ? s.d : s.l) / 100,
      pile: PILE_M[s.type] || 0.04,
      type: s.type,
      texture: this.texSource(this.variant()),
      room: s.room
    };
  };

  /* ---------------- Plan (Draufsicht, SVG) ---------------- */
  Configurator.prototype.drawPlan = function (valid) {
    var svg = $(this.root, '[data-tnm-plan]');
    if (!svg) return;
    var s = this.state, self = this;
    var W = s.shape === 'round' ? s.d : s.w, L = s.shape === 'round' ? s.d : s.l;
    if (!valid) { W = W && W >= this.cfg.minCm ? Math.min(W, this.cfg.maxCm) : 200; L = L && L >= this.cfg.minCm ? Math.min(L, this.cfg.maxCm) : 300; }
    var furn = furniturePlan(s.room, W, L);
    var minX = -W / 2, maxX = W / 2, minY = -L / 2, maxY = L / 2;
    furn.forEach(function (f) { minX = Math.min(minX, f.x); maxX = Math.max(maxX, f.x + f.w); minY = Math.min(minY, f.y); maxY = Math.max(maxY, f.y + f.h); });
    var pad = Math.max(maxX - minX, maxY - minY) * 0.16 + 30;
    var vbX = minX - pad, vbY = minY - pad, vbW = maxX - minX + pad * 2, vbH = maxY - minY + pad * 2;
    svg.setAttribute('viewBox', [vbX, vbY, vbW, vbH].join(' '));
    var fs = Math.max(vbW, vbH) / 34;
    var tile = PERIOD_M * 100;
    var img = this._planTex || '';
    var shape = s.shape === 'round'
      ? '<circle cx="0" cy="0" r="' + W / 2 + '" fill="url(#tnmFur)" stroke="rgba(0,0,0,.18)" stroke-width="' + fs * 0.08 + '"/>'
      : '<rect x="' + (-W / 2) + '" y="' + (-L / 2) + '" width="' + W + '" height="' + L + '" rx="' + Math.min(4, W / 40) + '" fill="url(#tnmFur)" stroke="rgba(0,0,0,.18)" stroke-width="' + fs * 0.08 + '"/>';
    var furnSvg = furn.map(function (f) {
      return '<rect x="' + f.x + '" y="' + f.y + '" width="' + f.w + '" height="' + f.h + '" rx="' + (f.r || 4) + '" class="tnm-plan__furn"/>' +
        (f.label ? '<text x="' + (f.x + f.w / 2) + '" y="' + (f.y + f.h / 2) + '" class="tnm-plan__furnlabel" font-size="' + fs * 0.7 + '" text-anchor="middle" dominant-baseline="middle">' + f.label + '</text>' : '');
    }).join('');
    var off = fs * 1.4, tick = fs * 0.35;
    var dimW = '<g class="tnm-plan__dim"><line x1="' + (-W / 2) + '" y1="' + (maxY + off) + '" x2="' + (W / 2) + '" y2="' + (maxY + off) + '"/>' +
      '<line x1="' + (-W / 2) + '" y1="' + (maxY + off - tick) + '" x2="' + (-W / 2) + '" y2="' + (maxY + off + tick) + '"/>' +
      '<line x1="' + (W / 2) + '" y1="' + (maxY + off - tick) + '" x2="' + (W / 2) + '" y2="' + (maxY + off + tick) + '"/>' +
      '<text x="0" y="' + (maxY + off + fs * 1.1) + '" font-size="' + fs + '" text-anchor="middle">' + (s.shape === 'round' ? 'Ø ' : '') + W + ' cm</text></g>';
    var dimL = s.shape === 'round' ? '' : '<g class="tnm-plan__dim"><line x1="' + (maxX + off) + '" y1="' + (-L / 2) + '" x2="' + (maxX + off) + '" y2="' + (L / 2) + '"/>' +
      '<line x1="' + (maxX + off - tick) + '" y1="' + (-L / 2) + '" x2="' + (maxX + off + tick) + '" y2="' + (-L / 2) + '"/>' +
      '<line x1="' + (maxX + off - tick) + '" y1="' + (L / 2) + '" x2="' + (maxX + off + tick) + '" y2="' + (L / 2) + '"/>' +
      '<text x="' + (maxX + off + fs * 0.6) + '" y="0" font-size="' + fs + '" dominant-baseline="middle" transform="rotate(90 ' + (maxX + off + fs * 0.6) + ' 0)" text-anchor="middle">' + L + ' cm</text></g>';
    // Maßstab 1 m
    var sbX = vbX + vbW - fs * 3.2 - 100, sbY = vbY + fs * 4.2; // oben rechts, unter der Werkzeugleiste
    var scale = '<g class="tnm-plan__scale"><line x1="' + sbX + '" y1="' + sbY + '" x2="' + (sbX + 100) + '" y2="' + sbY + '"/><text x="' + (sbX + 50) + '" y="' + (sbY - fs * 0.4) + '" font-size="' + fs * 0.8 + '" text-anchor="middle">1 m</text></g>';
    // Raster (50 cm)
    var grid = '<defs><pattern id="tnmGrid" width="50" height="50" patternUnits="userSpaceOnUse"><path d="M50 0H0V50" fill="none" class="tnm-plan__grid"/></pattern>' +
      '<pattern id="tnmFur" width="' + tile + '" height="' + tile + '" patternUnits="userSpaceOnUse" x="' + (-W / 2) + '" y="' + (-L / 2) + '">' +
      (img ? '<image href="' + img + '" width="' + tile + '" height="' + tile + '" preserveAspectRatio="xMidYMid slice"/>' : '<rect width="' + tile + '" height="' + tile + '" fill="' + (this._planAvg || '#d8cdbd') + '"/>') +
      '</pattern></defs><rect x="' + vbX + '" y="' + vbY + '" width="' + vbW + '" height="' + vbH + '" fill="url(#tnmGrid)"/>';
    svg.innerHTML = grid + shape + furnSvg + dimW + dimL + scale;
    svg.classList.toggle('is-invalid', !valid);

    // Textur asynchron nachladen
    var src = this.texSource(this.variant()), url = src.url + '|' + src.s + '|' + src.m;
    if (this._planTexUrl !== url) {
      this._planTexUrl = url;
      loadCrop(src).then(function (res) {
        if (self._planTexUrl !== url) return;
        self._planTex = res.dataUrl; self._planAvg = 'rgb(' + res.avg.join(',') + ')';
        self.drawPlan(Object.keys(self.errors()).length === 0);
      }).catch(function () {});
    }
  };

  /* Möbel in cm, y wächst "nach vorne" (Betrachter). Teppich liegt zentriert bei (0,0). */
  function furniturePlan(room, W, L) {
    var f = [];
    if (room === 'sofa') {
      // Sofa 220 × 90, vordere 20 cm stehen auf dem Teppich
      f.push({ x: -110, y: -L / 2 - 70, w: 220, h: 90, r: 10, label: 'Soffa 220 cm' });
      f.push({ x: -55, y: -30, w: 110, h: 60, r: 6, label: 'Bord' });
    } else if (room === 'bed') {
      // Bett 180 × 200, Kopfende 50 cm hinter dem Teppich
      f.push({ x: -90, y: -L / 2 - 50, w: 180, h: 200, r: 6, label: 'Säng 180×200' });
    } else if (room === 'dining') {
      f.push({ x: -100, y: -50, w: 200, h: 100, r: 4, label: 'Bord 200×100' });
      [-65, 0, 65].forEach(function (cx) {
        f.push({ x: cx - 22, y: -50 - 50, w: 44, h: 44, r: 6 });
        f.push({ x: cx - 22, y: 50 + 6, w: 44, h: 44, r: 6 });
      });
    }
    return f;
  }

  /* ---------------- Ansicht & 3D ---------------- */
  Configurator.prototype.setView = function (view) {
    this.state.view = view;
    var root = this.root;
    root.setAttribute('data-view', view);
    $$(root, '[data-tnm-view]').forEach(function (b) {
      var on = b.getAttribute('data-tnm-view') === view; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
    if (view === '3d') this.ensureThree();
  };

  Configurator.prototype.initStage = function () {
    var self = this;
    var canvasWrap = $(this.root, '[data-tnm-3d]');
    var hasWebGL = (function () { try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } })();
    if (!canvasWrap || !hasWebGL) { this.root.classList.add('no-3d'); this.setView('plan'); return; }
    this.setView('3d');
  };

  Configurator.prototype.ensureThree = function () {
    var self = this;
    if (this._threeLoading) return;
    this._threeLoading = true;
    var start = function () {
      loadThree().then(function (THREE) {
        self.three = new RugScene(THREE, $(self.root, '[data-tnm-3d]'), self.root);
        self.three.update(self.sceneState(Object.keys(self.errors()).length === 0));
        self.root.classList.add('is-3d-ready');
      }).catch(function (err) {
        console.warn('[NC Teppich] 3D nicht verfügbar:', err);
        self.root.classList.add('no-3d');
        self.setView('plan');
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: '300px' });
      io.observe(this.root);
    } else start();
  };

  /* three.js als ES-Modul über ein <script type="module"> laden.
     Kein import() im Code: Shopifys Asset-Minifier schreibt import() zu require() um. */
  function loadThree() {
    if (window.__ncThree) return Promise.resolve(window.__ncThree);
    if (window.__ncThreeP) return window.__ncThreeP;
    window.__ncThreeP = new Promise(function (resolve, reject) {
      var done = false;
      window.addEventListener('nc-three-ready', function () { done = true; resolve(window.__ncThree); }, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import * as T from ' + JSON.stringify(THREE_URL) + '; window.__ncThree = T; window.dispatchEvent(new Event("nc-three-ready"));';
      s.onerror = function () { reject(new Error('three.js konnte nicht geladen werden')); };
      document.head.appendChild(s);
      setTimeout(function () { if (!done) reject(new Error('three.js Timeout')); }, 20000);
    });
    return window.__ncThreeP;
  }

  function RugScene(THREE, wrap, root) {
    this.T = THREE; this.wrap = wrap; this.root = root;
    var T = THREE;
    var renderer = this.renderer = new T.WebGLRenderer({ antialias: true, alpha: false, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;
    renderer.outputColorSpace = T.SRGBColorSpace;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    wrap.appendChild(renderer.domElement);

    var scene = this.scene = new T.Scene();
    scene.background = new T.Color(0xf3efe9);
    scene.fog = new T.Fog(0xf3efe9, 14, 30);

    this.camera = new T.PerspectiveCamera(35, 1, 0.05, 100);

    // Licht: weiches Tageslicht von links oben + Umgebungslicht
    scene.add(new T.HemisphereLight(0xfffaf2, 0xd9cfc2, 1.15));
    var sun = this.sun = new T.DirectionalLight(0xfff4e6, 1.6);
    sun.position.set(-4, 7, 3);
    sun.castShadow = true;
    sun.shadow.mapSize.set(2048, 2048);
    sun.shadow.camera.left = -8; sun.shadow.camera.right = 8; sun.shadow.camera.top = 8; sun.shadow.camera.bottom = -8;
    sun.shadow.radius = 6; sun.shadow.bias = -0.0005;
    scene.add(sun);

    // Boden: helle Eichendielen (prozedural)
    var floorTex = new T.CanvasTexture(woodCanvas());
    floorTex.wrapS = floorTex.wrapT = T.RepeatWrapping;
    floorTex.repeat.set(24 / 0.9, 24 / 0.9); // Kachel = 0,9 m -> Dielen 9 x 45 cm (Fischgrät)
    floorTex.center.set(0.5, 0.5); floorTex.rotation = Math.PI / 4;
    floorTex.colorSpace = T.SRGBColorSpace;
    floorTex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    var floor = new T.Mesh(new T.PlaneGeometry(24, 24), new T.MeshStandardMaterial({ map: floorTex, roughness: 0.85 }));
    floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true;
    scene.add(floor);

    this.rugGroup = new T.Group(); scene.add(this.rugGroup);
    this.furnGroup = new T.Group(); scene.add(this.furnGroup);
    this.furnMat = new T.MeshStandardMaterial({ color: 0xe4ddd3, roughness: 0.9 });
    this.woodMat = new T.MeshStandardMaterial({ color: 0xb08c68, roughness: 0.7 });

    // einfache Orbit-Steuerung (Ziehen = drehen, Pinch/Rad = zoomen)
    this.orbit = { theta: -0.6, phi: 0.95, radius: 6, target: new T.Vector3(0, 0, 0) };
    this.goal = { theta: -0.6, phi: 0.95, radius: 6 };
    this.autoRotate = true;
    this.bindControls();

    var self = this;
    this.resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.resize(); }).observe(wrap);
    this.visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { self.visible = en[0].isIntersecting; if (self.visible) self.loop(); }).observe(wrap);
    this.loop();
  }

  RugScene.prototype.resize = function () {
    var r = this.wrap.getBoundingClientRect();
    if (!r.width || !r.height) return;
    this.renderer.setSize(r.width, r.height, false);
    this.camera.aspect = r.width / r.height;
    this.camera.updateProjectionMatrix();
    this.dirty = true;
  };

  RugScene.prototype.bindControls = function () {
    var self = this, el = this.wrap, pointers = {}, lastDist = 0;
    el.style.touchAction = 'pan-y';
    el.addEventListener('pointerdown', function (e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      el.setPointerCapture(e.pointerId);
      self.autoRotate = false; self.root.classList.add('has-interacted');
    });
    el.addEventListener('pointermove', function (e) {
      var p = pointers[e.pointerId]; if (!p) return;
      var ids = Object.keys(pointers);
      if (ids.length === 1) {
        var dx = e.clientX - p.x, dy = e.clientY - p.y;
        self.goal.theta -= dx * 0.008;
        self.goal.phi = Math.min(1.45, Math.max(0.05, self.goal.phi - dy * 0.006));
        if (Math.abs(dy) > Math.abs(dx) && e.pointerType === 'touch') { /* vertikales Wischen: Seite scrollen lassen */ }
      } else if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        if (lastDist) self.goal.radius = Math.min(self.maxR || 20, Math.max(self.minR || 1.5, self.goal.radius * lastDist / dist));
        lastDist = dist;
      }
      p.x = e.clientX; p.y = e.clientY;
      self.dirty = true; self.loop();
    });
    var up = function (e) { delete pointers[e.pointerId]; lastDist = 0; };
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    el.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !self.root.classList.contains('has-interacted')) return; // Seite normal scrollen, bis der Nutzer interagiert hat
      e.preventDefault();
      self.goal.radius = Math.min(self.maxR || 20, Math.max(self.minR || 1.5, self.goal.radius * (1 + e.deltaY * 0.001)));
      self.dirty = true; self.loop();
    }, { passive: false });
  };

  RugScene.prototype.topView = function () {
    this.autoRotate = false; this.goal.phi = 0.06; this.goal.theta = 0; this.dirty = true; this.loop();
  };

  RugScene.prototype.loop = function () {
    if (this._raf) return;
    var self = this;
    var tick = function () {
      self._raf = null;
      if (!self.visible) return;
      var o = self.orbit, g = self.goal;
      if (self.autoRotate) g.theta += 0.0022;
      var k = 0.12, moving = false;
      ['theta', 'phi', 'radius'].forEach(function (key) {
        var d = g[key] - o[key];
        if (Math.abs(d) > 0.0005) { o[key] += d * k; moving = true; } else o[key] = g[key];
      });
      var sp = Math.sin(o.phi);
      self.camera.position.set(o.target.x + o.radius * sp * Math.sin(o.theta), o.target.y + o.radius * Math.cos(o.phi), o.target.z + o.radius * sp * Math.cos(o.theta));
      self.camera.lookAt(o.target);
      if (moving || self.dirty || self.autoRotate) {
        if (self.autoRotate) self.placeShells(performance.now());
        self.renderer.render(self.scene, self.camera);
        self.dirty = false;
      }
      if (moving || self.autoRotate) self._raf = requestAnimationFrame(tick);
    };
    this._raf = requestAnimationFrame(tick);
  };

  RugScene.prototype.update = function (st) {
    var T = this.T, self = this;
    this.state = st;
    // Teppich neu aufbauen
    this.rugGroup.clear();
    var w = st.w || 2, l = st.l || 3, h = st.pile;
    var shape = rugShape(T, st);
    var fur = FUR[st.type] || FUR.langhaar, hb = Math.max(0.008, h * fur.base);
    var bevel = Math.min(hb * 0.6, 0.02);
    var geo = new T.ExtrudeGeometry(shape, { depth: Math.max(0.004, hb - bevel), bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel * 0.8, bevelSegments: 4, curveSegments: 64 });
    geo.rotateX(-Math.PI / 2);
    geo.translate(0, bevel, 0);
    if (!this.rugMat) {
      this.rugMat = new T.MeshPhysicalMaterial({ color: 0xb8b8b8, roughness: 1, sheen: 1, sheenRoughness: 0.75, sheenColor: new T.Color(0xffffff) });
    }
    var mesh = new T.Mesh(geo, this.rugMat);
    mesh.castShadow = true; mesh.receiveShadow = true;
    this.rugGroup.add(mesh);

    // Fellschichten
    if (this._strandType !== st.type) {
      if (this._strands) this._strands.dispose();
      this._strands = new T.CanvasTexture(strandCanvas(st.type || 'langhaar'));
      this._strands.wrapS = this._strands.wrapT = T.RepeatWrapping;
      this._strands.repeat.set(2, 2);                    // UV in Metern -> 1 Kachel = 0,5 m
      this._strands.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
      this._strandType = st.type;
    }
    var top = new T.ShapeGeometry(shape, 64);
    top.rotateX(-Math.PI / 2);
    this.shellMats = this.shellMats || [];
    this.shells = [];
    this.fur = fur;
    var N = fur.layers, grow = Math.min(0.012, h * 0.2);
    for (var i = 1; i <= N; i++) {
      var t = i / N;
      var m = this.shellMats[i] || (this.shellMats[i] = new T.MeshStandardMaterial({ roughness: 1, metalness: 0, alphaTest: 0.5 }));
      m.map = this._tex || null; m.alphaMap = this._strands;
      m.alphaTest = Math.min(0.96, 0.08 + Math.pow(t, 0.85) * 0.88);
      var shade = 0.6 + 0.4 * Math.pow(t, 0.7);        // Unterwolle dunkler (Eigenschattierung)
      m.color.setRGB(shade, shade * 0.99, shade * 0.97);
      m.needsUpdate = true;
      var sh = new T.Mesh(top, m);
      sh.position.y = hb + (h - hb) * t;
      sh.scale.set(1 + 2 * grow * t / w, 1, 1 + 2 * grow * t / l); // Fell wölbt sich über die Kante
      sh.userData.t = t; sh.receiveShadow = true; sh.renderOrder = i;
      this.rugGroup.add(sh); this.shells.push(sh);
    }
    this.placeShells(0);
    this.rugGroup.visible = !!st.valid || true;
    this.loadTexture(st.texture);

    // Möbel
    this.furnGroup.clear();
    buildFurniture(T, this.furnGroup, st.room, w, l, this.furnMat, this.woodMat);

    // Kamera-Abstand an Größe anpassen
    var box = new T.Box3().setFromObject(this.furnGroup.children.length ? this.furnGroup : this.rugGroup).union(new T.Box3().setFromObject(this.rugGroup));
    var size = box.getSize(new T.Vector3());
    var span = Math.max(size.x, size.z, 1.2);
    this.minR = span * 0.7; this.maxR = span * 4;
    this.goal.radius = span * 1.9 + 0.8;
    this.orbit.target.set(0, 0, 0);
    this.dirty = true; this.loop();
  };

  function rugShape(T, st) {
    var w = st.w || 2, l = st.l || 3, shape = new T.Shape();
    if (st.shape === 'round') {
      shape.absarc(0, 0, w / 2, 0, Math.PI * 2, false);
    } else {
      var r = Math.min(0.04, w / 20), x = -w / 2, y = -l / 2;
      shape.moveTo(x + r, y); shape.lineTo(x + w - r, y); shape.quadraticCurveTo(x + w, y, x + w, y + r);
      shape.lineTo(x + w, y + l - r); shape.quadraticCurveTo(x + w, y + l, x + w - r, y + l);
      shape.lineTo(x + r, y + l); shape.quadraticCurveTo(x, y + l, x, y + l - r);
      shape.lineTo(x, y + r); shape.quadraticCurveTo(x, y, x + r, y);
    }
    return shape;
  }

  RugScene.prototype.placeShells = function (time) {
    if (!this.shells || !this.fur) return;
    var f = this.fur, sway = f.sway * Math.sin(time * 0.0009), sway2 = f.sway * 0.6 * Math.cos(time * 0.0007);
    for (var i = 0; i < this.shells.length; i++) {
      var sh = this.shells[i], t = sh.userData.t, k = t * t;
      sh.position.x = (f.lean + sway) * k;
      sh.position.z = (f.lean * 0.35 + sway2) * k;
    }
  };

  RugScene.prototype.loadTexture = function (src) {
    var T = this.T, self = this, url = typeof src === 'string' ? src : src.url + '|' + src.s + '|' + src.m;
    if (this._texUrl === url && this._tex) { this.applyRepeat(); return; }
    this._texUrl = url;
    loadCrop(src).then(function (res) {
      if (self._texUrl !== url) return;
      var tex = new T.CanvasTexture(res.canvas);
      tex.wrapS = tex.wrapT = T.RepeatWrapping;
      tex.colorSpace = T.SRGBColorSpace;
      tex.anisotropy = self.renderer.capabilities.getMaxAnisotropy();
      var bump = new T.CanvasTexture(res.canvas);
      bump.wrapS = bump.wrapT = T.RepeatWrapping;
      if (self._tex) { self._tex.dispose(); self._bump.dispose(); }
      self._tex = tex; self._bump = bump;
      self.rugMat.map = tex; self.rugMat.bumpMap = bump; self.rugMat.bumpScale = 2.2;
      (self.shellMats || []).forEach(function (m) { if (m) { m.map = tex; m.needsUpdate = true; } });
      self.rugMat.sheenColor = new T.Color('rgb(' + res.avg.join(',') + ')').multiplyScalar(1.15);
      self.rugMat.needsUpdate = true;
      self.applyRepeat();
    }).catch(function () {
      self.rugMat.map = null; self.rugMat.color = new T.Color(0xd8cdbd); self.rugMat.needsUpdate = true;
      (self.shellMats || []).forEach(function (m) { if (m) { m.map = null; m.color.setHex(0xd8cdbd); m.needsUpdate = true; } });
      self.dirty = true; self.loop();
    });
  };

  RugScene.prototype.applyRepeat = function () {
    // UVs der ExtrudeGeometry sind in Metern -> 1 Kachel = TILE_M
    [this._tex, this._bump].forEach(function (t) { if (t) { t.repeat.set(1 / PERIOD_M, 1 / PERIOD_M); t.needsUpdate = true; } });
    this.dirty = true; this.loop();
  };

  function box(T, g, mat, w, h, d, x, y, z) {
    var m = new T.Mesh(new T.BoxGeometry(w, h, d), mat);
    m.position.set(x, y + h / 2, z); m.castShadow = true; m.receiveShadow = true; g.add(m); return m;
  }

  /* Maße in Metern; Teppich zentriert, Länge entlang z (Betrachter = +z) */
  function buildFurniture(T, g, room, w, l, mat, wood) {
    if (room === 'sofa') {
      var zBack = -l / 2 - 0.70; // Sofa 90 cm tief, vorne 20 cm auf dem Teppich
      box(T, g, mat, 2.2, 0.42, 0.9, 0, 0.02, zBack + 0.45);          // Sitz
      box(T, g, mat, 2.2, 0.45, 0.2, 0, 0.44, zBack + 0.1);           // Rücken
      box(T, g, mat, 0.18, 0.2, 0.9, -1.01, 0.44, zBack + 0.45);      // Armlehnen
      box(T, g, mat, 0.18, 0.2, 0.9, 1.01, 0.44, zBack + 0.45);
      box(T, g, wood, 1.1, 0.04, 0.6, 0, 0.36, 0);                    // Couchtisch
      [[-0.5, -0.25], [0.5, -0.25], [-0.5, 0.25], [0.5, 0.25]].forEach(function (p) { box(T, g, wood, 0.04, 0.36, 0.04, p[0], 0, p[1]); });
    } else if (room === 'bed') {
      var zHead = -l / 2 - 0.5;
      box(T, g, wood, 1.9, 0.25, 2.1, 0, 0, zHead + 1.05);            // Bettrahmen
      box(T, g, mat, 1.8, 0.25, 2.0, 0, 0.25, zHead + 1.05);          // Matratze
      box(T, g, mat, 1.9, 1.1, 0.1, 0, 0, zHead);                      // Kopfteil
    } else if (room === 'dining') {
      box(T, g, wood, 2.0, 0.04, 1.0, 0, 0.72, 0);
      [[-0.92, -0.42], [0.92, -0.42], [-0.92, 0.42], [0.92, 0.42]].forEach(function (p) { box(T, g, wood, 0.06, 0.72, 0.06, p[0], 0, p[1]); });
      [-0.65, 0, 0.65].forEach(function (cx) {
        [-1, 1].forEach(function (side) {
          var cz = side * 0.78;
          box(T, g, mat, 0.44, 0.06, 0.44, cx, 0.42, cz);
          box(T, g, mat, 0.44, 0.45, 0.05, cx, 0.48, cz + side * 0.2);
          [[-0.19, -0.19], [0.19, -0.19], [-0.19, 0.19], [0.19, 0.19]].forEach(function (p) { box(T, g, wood, 0.03, 0.42, 0.03, cx + p[0], 0, cz + p[1]); });
        });
      });
    }
  }

  function woodCanvas() {
    // Fischgrät-Parkett: Treppenmuster aus Dielen L x 1 (Einheit = Dielenbreite),
    // Gitter (1,1) und (2L,0) -> Kachel 2L x 2L ist nahtlos. Drehung um 45° erfolgt per UV.
    var S = 1024, L = 5, P = 2 * L, u = S / P;
    var c = document.createElement('canvas'); c.width = S; c.height = S;
    var ctx = c.getContext('2d');
    function hash(a, b, t) { var h = (a * 73856093) ^ (b * 19349663) ^ (t * 83492791); return mulberry(h)(); }
    function mod(a, m) { return ((a % m) + m) % m; }
    function plank(x0, y0, w, h, horiz) {
      var key = hash(mod(x0, P), mod(y0, P), horiz ? 1 : 2), r = mulberry(Math.floor(key * 1e9));
      var base = 206 + key * 26;
      var px = x0 * u, py = y0 * u, pw = w * u, ph = h * u;
      ctx.save(); ctx.beginPath(); ctx.rect(px, py, pw, ph); ctx.clip();
      ctx.fillStyle = 'rgb(' + Math.round(base) + ',' + Math.round(base * 0.88) + ',' + Math.round(base * 0.74) + ')';
      ctx.fillRect(px, py, pw, ph);
      // Maserung entlang der Dielenlänge
      for (var k = 0; k < 16; k++) {
        ctx.strokeStyle = 'rgba(120,90,60,' + (0.03 + r() * 0.05) + ')';
        ctx.lineWidth = 0.8 + r() * 2;
        var o = r(), wig = (r() - 0.5) * 10;
        ctx.beginPath();
        if (horiz) { var gy = py + o * ph; ctx.moveTo(px, gy); ctx.bezierCurveTo(px + pw * 0.33, gy + wig, px + pw * 0.66, gy - wig, px + pw, gy + wig * 0.4); }
        else { var gx = px + o * pw; ctx.moveTo(gx, py); ctx.bezierCurveTo(gx + wig, py + ph * 0.33, gx - wig, py + ph * 0.66, gx + wig * 0.4, py + ph); }
        ctx.stroke();
      }
      // leichte Helligkeitsverlauf + Fuge
      var g = horiz ? ctx.createLinearGradient(px, 0, px + pw, 0) : ctx.createLinearGradient(0, py, 0, py + ph);
      g.addColorStop(0, 'rgba(255,240,220,' + (r() * 0.08) + ')'); g.addColorStop(1, 'rgba(60,40,20,' + (r() * 0.08) + ')');
      ctx.fillStyle = g; ctx.fillRect(px, py, pw, ph);
      ctx.strokeStyle = 'rgba(95,70,45,.38)'; ctx.lineWidth = 1.4; ctx.strokeRect(px + 0.8, py + 0.8, pw - 1.6, ph - 1.6);
      ctx.restore();
    }
    for (var tx = -1; tx <= 1; tx++) for (var ty = -1; ty <= 1; ty++) {
      for (var n = -P; n < 2 * P; n++) {
        var ox = tx * P, oy = ty * P;
        plank(n + ox, n + oy, L, 1, true);          // waagerecht
        plank(n + ox, n + 1 + oy, 1, L, false);     // senkrecht
      }
    }
    return c;
  }
  function mulberry(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  /* ---------------- AR: Im Raum ansehen ---------------- */
  var _mvP = null, _qrP = null;
  function loadModelViewer() {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (_mvP) return _mvP;
    _mvP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.type = 'module'; sc.src = MV_URL;
      sc.onload = function () { customElements.whenDefined('model-viewer').then(res); };
      sc.onerror = function () { _mvP = null; rej(new Error('model-viewer')); };
      document.head.appendChild(sc);
    });
    return _mvP;
  }
  function loadQR() {
    if (window.qrcode) return Promise.resolve(window.qrcode);
    if (_qrP) return _qrP;
    _qrP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = QR_URL;
      sc.onload = function () { window.qrcode ? res(window.qrcode) : rej(new Error('qrcode')); };
      sc.onerror = function () { _qrP = null; rej(new Error('qrcode')); };
      document.head.appendChild(sc);
    });
    return _qrP;
  }

  Configurator.prototype.initAR = function () {
    var btn = $(this.root, '[data-tnm-ar]'); if (!btn) return;
    var ua = navigator.userAgent;
    var mobile = /Android|iPhone|iPad|iPod/i.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua));
    this.ar = { mobile: mobile };
    btn.hidden = false;
    if (mobile && new URLSearchParams(window.location.search).get('ar') === '1') btn.classList.add('is-pulse');
  };

  Configurator.prototype.onAR = function () {
    var self = this;
    if (!this.ar) this.initAR();
    if (!this.ar.mobile) { this.showQR(); return; }
    var btn = $(this.root, '[data-tnm-ar]'), label = $(btn, '[data-tnm-ar-label]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    if (!this.three || !this.three._tex) { this.ensureThree && this.ensureThree(); label.textContent = 'Ett ögonblick …'; setTimeout(function () { label.textContent = 'Se i ditt rum'; }, 1800); return; }
    btn.setAttribute('aria-busy', 'true'); label.textContent = 'Förbereds …';
    var st = this.sceneState(true), v = this.variant(), t = this.type();
    Promise.all([loadModelViewer(), this.three.exportGLB(st)]).then(function (r) {
      var url = URL.createObjectURL(r[1]);
      var dims = st.shape === 'round' ? 'Ø ' + Math.round(st.w * 100) + ' cm' : Math.round(st.w * 100) + ' × ' + Math.round(st.l * 100) + ' cm';
      self.openARSheet(url, t.label + ' · ' + v.name, dims);
    }).catch(function () {
      label.textContent = 'Inte tillgängligt'; setTimeout(function () { label.textContent = 'Se i ditt rum'; }, 2600);
    }).then(function () { btn.removeAttribute('aria-busy'); if (label.textContent === 'Förbereds …') label.textContent = 'Se i ditt rum'; });
  };

  Configurator.prototype.openARSheet = function (url, title, dims) {
    var sheet = document.createElement('div');
    sheet.className = 'tnm-arsheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Se i ditt rum');
    sheet.innerHTML = '<div class="tnm-arsheet__head"><div><span></span><strong></strong></div>' +
      '<button type="button" class="tnm-arsheet__x" aria-label="Stäng"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 5l14 14M19 5 5 19"/></svg></button></div>' +
      '<model-viewer ar ar-modes="webxr quick-look" ar-placement="floor" ar-scale="fixed" camera-controls touch-action="pan-y" auto-rotate rotation-per-second="12deg" shadow-intensity="1" shadow-softness="0.9" exposure="1.05" camera-orbit="30deg 62deg auto" loading="eager" alt="Din matta i full storlek">' +
      '<button slot="ar-button" type="button" class="tnm-arsheet__go"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2.8 20 7.3v9.4l-8 4.5-8-4.5V7.3z"/><path d="M4 7.3l8 4.5 8-4.5M12 11.8v9.4"/></svg>Placera i rummet</button>' +
      '</model-viewer><p class="tnm-arsheet__note" hidden>AR är tyvärr inte tillgängligt på den här enheten – vrid din matta här i 3D.</p>';
    sheet.querySelector('.tnm-arsheet__head span').textContent = title;
    sheet.querySelector('.tnm-arsheet__head strong').textContent = dims + ' · Full storlek';
    var mv = sheet.querySelector('model-viewer');
    mv.src = url;
    var prevOverflow = document.documentElement.style.overflow;
    var close = function () {
      sheet.classList.remove('is-open'); document.documentElement.style.overflow = prevOverflow;
      setTimeout(function () { sheet.remove(); URL.revokeObjectURL(url); }, 350);
      document.removeEventListener('keydown', onKey);
    };
    var onKey = function (e) { if (e.key === 'Escape') close(); };
    sheet.querySelector('.tnm-arsheet__x').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    mv.addEventListener('load', function () {
      setTimeout(function () { if (!mv.canActivateAR) sheet.querySelector('.tnm-arsheet__note').hidden = false; }, 400);
    });
    document.body.appendChild(sheet);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    sheet.querySelector('.tnm-arsheet__x').focus();
  };

  Configurator.prototype.showQR = function () {
    var box = $(this.root, '[data-tnm-arqr]'); if (!box) return;
    if (!box.hidden) { box.hidden = true; return; }
    var u = new URL(this.shareUrl()); u.searchParams.set('ar', '1');
    var code = $(box, '[data-tnm-arqr-code]');
    box.hidden = false;
    loadQR().then(function (qrcode) {
      var qr = qrcode(0, 'M'); qr.addData(u.toString()); qr.make();
      code.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
    }).catch(function () { code.textContent = ''; });
  };

  /* GLB (glTF binär) ohne Zusatzbibliothek: Teppichkörper in Originalgröße mit eingebrannter Felltextur */
  function buildGLB(pos, nor, uv, img) {
    var pad4 = function (n) { return (n + 3) & ~3; };
    var n = pos.length / 3, pB = pos.byteLength, nB = nor.byteLength, uB = uv.byteLength, iB = img.byteLength;
    var offN = pad4(pB), offU = offN + pad4(nB), offI = offU + pad4(uB), binLen = pad4(offI + iB);
    var bin = new Uint8Array(binLen);
    bin.set(new Uint8Array(pos.buffer, pos.byteOffset, pB), 0);
    bin.set(new Uint8Array(nor.buffer, nor.byteOffset, nB), offN);
    bin.set(new Uint8Array(uv.buffer, uv.byteOffset, uB), offU);
    bin.set(img, offI);
    var min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity];
    for (var i = 0; i < n; i++) for (var k = 0; k < 3; k++) { var q = pos[i * 3 + k]; if (q < min[k]) min[k] = q; if (q > max[k]) max[k] = q; }
    var json = {
      asset: { version: '2.0', generator: 'NATURES Collection Matta efter mått' },
      scene: 0, scenes: [{ nodes: [0] }], nodes: [{ mesh: 0, name: 'Matta' }],
      meshes: [{ primitives: [{ attributes: { POSITION: 0, NORMAL: 1, TEXCOORD_0: 2 }, material: 0 }] }],
      materials: [{ name: 'Lammskinn', pbrMetallicRoughness: { baseColorTexture: { index: 0 }, metallicFactor: 0, roughnessFactor: 1 } }],
      textures: [{ source: 0, sampler: 0 }],
      samplers: [{ magFilter: 9729, minFilter: 9987, wrapS: 33071, wrapT: 33071 }],
      images: [{ bufferView: 3, mimeType: 'image/jpeg' }],
      buffers: [{ byteLength: binLen }],
      bufferViews: [
        { buffer: 0, byteOffset: 0, byteLength: pB, target: 34962 },
        { buffer: 0, byteOffset: offN, byteLength: nB, target: 34962 },
        { buffer: 0, byteOffset: offU, byteLength: uB, target: 34962 },
        { buffer: 0, byteOffset: offI, byteLength: iB }
      ],
      accessors: [
        { bufferView: 0, componentType: 5126, count: n, type: 'VEC3', min: min, max: max },
        { bufferView: 1, componentType: 5126, count: n, type: 'VEC3' },
        { bufferView: 2, componentType: 5126, count: n, type: 'VEC2' }
      ]
    };
    var jb = new TextEncoder().encode(JSON.stringify(json)), jLen = pad4(jb.length);
    var total = 12 + 8 + jLen + 8 + binLen, out = new ArrayBuffer(total), dv = new DataView(out), u8 = new Uint8Array(out);
    dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true);
    dv.setUint32(12, jLen, true); dv.setUint32(16, 0x4E4F534A, true); u8.set(jb, 20);
    for (var p = 20 + jb.length; p < 20 + jLen; p++) u8[p] = 0x20;
    var o = 20 + jLen; dv.setUint32(o, binLen, true); dv.setUint32(o + 4, 0x004E4942, true); u8.set(bin, o + 8);
    return new Blob([out], { type: 'model/gltf-binary' });
  }

  RugScene.prototype.exportGLB = function (st) {
    var T = this.T, w = st.w || 2, l = st.l || 3, h = Math.max(0.02, (st.pile || 0.04) * 0.7);
    var shape = rugShape(T, st), bevel = Math.min(h * 0.5, 0.015);
    var geo = new T.ExtrudeGeometry(shape, { depth: Math.max(0.004, h - 2 * bevel), bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel * 0.8, bevelSegments: 3, curveSegments: 48 });
    geo.rotateX(-Math.PI / 2); geo.translate(0, bevel, 0);
    if (geo.index) geo = geo.toNonIndexed();
    geo.computeBoundingBox();                                   // Fase vergrößert die Kontur -> exakt auf Bestellmaß skalieren
    var bb = geo.boundingBox, sx = w / (bb.max.x - bb.min.x), sz = l / (bb.max.z - bb.min.z);
    geo.scale(sx, 1, sz);
    geo.computeVertexNormals();
    var pos = geo.attributes.position.array, nor = geo.attributes.normal.array, cnt = pos.length / 3, uv = new Float32Array(cnt * 2);
    for (var i = 0; i < cnt; i++) { uv[i * 2] = (pos[i * 3] + w / 2) / w; uv[i * 2 + 1] = (pos[i * 3 + 2] + l / 2) / l; }
    var ppm = Math.min(600, 2048 / Math.max(w, l)), cw = Math.max(64, Math.round(w * ppm)), ch = Math.max(64, Math.round(l * ppm));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var ctx = c.getContext('2d'), src = this._tex && this._tex.image;
    if (src) {
      var pat = ctx.createPattern(src, 'repeat'), k = ppm * PERIOD_M / src.width;
      if (pat.setTransform && window.DOMMatrix) pat.setTransform(new DOMMatrix().scale(k, k));
      ctx.fillStyle = pat; ctx.fillRect(0, 0, cw, ch);
    } else { ctx.fillStyle = '#d8cdbd'; ctx.fillRect(0, 0, cw, ch); }
    geo.dispose();
    return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.9); })
      .then(function (b) { return b.arrayBuffer(); })
      .then(function (buf) { return buildGLB(pos, nor, uv, new Uint8Array(buf)); });
  };

  /* ---------------- Teilen & Warenkorb ---------------- */
  Configurator.prototype.share = function (btn) {
    var url = this.shareUrl(), label = btn.querySelector('span') || btn, orig = label.textContent, s = this.cfg.strings;
    var done = function () { label.textContent = s.copied; setTimeout(function () { label.textContent = orig; }, 2200); };
    if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
    } else window.prompt('', url);
  };

  Configurator.prototype.addToCart = function () {
    var self = this, c = this.cfg, s = this.state, t = this.type(), v = this.variant(), r = this.result;
    if (!r) return;
    if (!this.engaged) { this.engage(); this.update(); return; }
    var btns = $$(this.root, '[data-tnm-add]');
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var dims = s.shape === 'round' ? 'Ø ' + s.d + ' cm' : s.w + ' × ' + s.l + ' cm';
    var item = null;
    var props = {};
    props[c.strings.propType] = t.label;
    props[c.strings.propShape] = s.shape === 'round' ? c.strings.round : c.strings.rect;
    props[c.strings.propDims] = dims;
    props[c.strings.propArea] = num(r.m2, 2, c.locale) + ' m²' + (s.shape === 'round' ? ' (' + c.strings.roundCalc + ')' : '');
    props['_tnm'] = '1';
    props['_tnm_cm2'] = String(r.cm2);
    props['_tnm_shape'] = s.shape;
    props['_tnm_w'] = String(s.shape === 'round' ? s.d : s.w);
    props['_tnm_l'] = String(s.shape === 'round' ? s.d : s.l);
    props['_tnm_total'] = String(r.totalCents);

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item || { id: v.id, quantity: r.quantity, properties: props }], sections: sections.join(',') })
    }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
      .then(function (out) {
        if (!out.ok) throw new Error(out.json.description || out.json.message || 'Fel');
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = out.json.sections;
          if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
            window.location.href = window.Shopify.routes.root + 'cart'; return;
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          self.flash(c.strings.added, false);
        });
      })
      .catch(function (err) {
        self.flash(c.strings.addError + ' ' + (err && err.message ? err.message : ''), true);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .then(function () {
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
        self.update();
      });
  };

  Configurator.prototype.flash = function (msg, isErr) {
    var el = $(this.root, '[data-tnm-flash]');
    if (!el) return;
    el.textContent = msg; el.classList.toggle('is-error', !!isErr); el.hidden = false;
    clearTimeout(this._flashT); this._flashT = setTimeout(function () { el.hidden = true; }, 5000);
  };

  /* ---------------- Start ---------------- */
  function init() {
    $$(document, '[data-tnm-root]:not([data-tnm-ready])').forEach(function (root) {
      root.setAttribute('data-tnm-ready', '');
      try { root._tnm = new Configurator(root); } catch (e) { console.error('[NC Teppich]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
